// Auto-generated file - do not edit manually
export const LOCALE_HASH = 'a649d4d6';
